(function ($) {
    if ($('.steps-content-block').length) {
        $('#tabs li').on('click', function() {
            const tab = $(this).data('tab');

            if ($(this).hasClass('inactive')) {
                $('#tabs li').addClass('inactive');
                $(this).removeClass('inactive');

                $('.single-tab-content').removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');
                $('.steps-navigation li').removeClass('visible').filter(`[data-tab="${tab}"]`).addClass('visible');
                $('.step-title.visible').removeClass('previous-step');
                $(`.step-title[data-tab="${tab}"]`).eq(0).addClass('active');
            }
            AOS.refresh()
        });

        $('.toggle-list-mobile .header').on('click', function () {
            const parent = $(this).closest('.toggle-list-mobile');
            const nav = parent.find('ul');

            parent.toggleClass('active');
            nav.slideToggle();
        });

        $('.toggle-list-mobile li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const parent = $(this).closest('.toggle-list-mobile');
            const tabName = $(this).text();
            const nav = $(parent).find('ul');
            const tab = $(this).data('tab');

            $(this).addClass('active').siblings().removeClass('active');
            parent.toggleClass('active');
            nav.slideToggle();
            parent.find('.header p').text(tabName);

            $('.single-tab-content').removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');
            $('.steps-navigation li').removeClass('visible').filter(`[data-tab="${tab}"]`).addClass('visible');
            $('.step-title.visible').removeClass('previous-step');
            $(`.step-title[data-tab="${tab}"]`).eq(0).addClass('active');
        });

        $('.steps-navigation .step-title').on('click', function() {
           const title = $(this).data('title');

            $('html, body').animate({
                scrollTop: $(`.single-tab-content.active[data-title="${title}"]`).offset().top - 30
            }, 500);
        });

        $(window).on('scroll', function() {
           const scrollTop = $(window).scrollTop();

            $('.single-tab-content.active').each(function(index, el) {
                if (scrollTop >= $(el).offset().top - 50) {
                    const title = $(el).closest('.single-tab-content').data('title');
                    $('.step-title').removeClass('active previous-step').filter(`[data-title="${title}"]`).addClass('active');
                    $('.step-title.visible.active').prevAll().addClass('previous-step');
                }
            })
        });
    }
})(jQuery);